import { StrictMode, useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { App as AntApp, ConfigProvider } from 'antd'
import ptBR from 'antd/locale/pt_BR'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { NewVersionScreen } from './components/NewVersionScreen'
import { AuthProvider } from './lib/auth'
import { installDeployDetector, onDeployDetected } from './lib/deployDetector'
import { antdTheme } from './lib/theme'
import './styles/global.css'

installDeployDetector()

/** Deploy detectado fora do React (preload de chunk, promise rejeitada) também
 *  precisa trocar a tela — por isso o aviso vive acima do App. */
function Root() {
  const [newVersion, setNewVersion] = useState(false)
  useEffect(() => onDeployDetected(() => setNewVersion(true)), [])

  if (newVersion) return <NewVersionScreen />

  return (
    <ConfigProvider locale={ptBR} theme={antdTheme}>
      <AntApp>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  )
}

const container = document.getElementById('root')
if (!container) throw new Error('#root não encontrado')

createRoot(container).render(
  <StrictMode>
    <Root />
  </StrictMode>,
)
